import { useQuery } from '@tanstack/react-query';
import { FC } from 'react';
import { LocationDetailsFleetButton } from 'src/locations/LocationDetailsFleetButton';
import { fetchSimInventoryEntry } from 'src/simInventory/SimInventoryApi/simInventoryApi';
import { simDetailsQueries } from 'src/simInventory/SimInventoryDetails/queries/simDetailsQueries';

type SimLocationDetailsFleetButtonProps = {
  iccid: string;
};

export const SimLocationDetailsFleetButton: FC<SimLocationDetailsFleetButtonProps> = (props) => {
  const { iccid } = props;

  const { data, status } = useQuery({
    queryKey: simDetailsQueries.detail({ iccid }),
    queryFn: async ({ signal }) => {
      return fetchSimInventoryEntry(iccid, undefined, signal);
    },
    meta: {
      isLocationsDetails: true,
    },
  });

  if (status === 'pending') {
    return <LocationDetailsFleetButton loading={true} />;
  }

  if (status === 'success' && data.accountRef) {
    return <LocationDetailsFleetButton loading={false} accountId={data.accountRef} />;
  }

  return null;
};
